import { component } from 'picoapp'

export default component((node, ctx) => {
    /**
     * Country select
     */
    const { themes, current } = ctx.getState().theme
    const activeTag = node.querySelector('[data-active]')
    const flag = node.querySelector('[data-country-flag]')

    const assetUrl = (file) => {
        const str = theme.assetUrl.replace('x.x', file)
        return str
    }

    const {
        metafields: { image: hasImage, country, language },
    } = current;

    if (country === 'SE') return
    const image = hasImage ? hasImage : `${country.toLowerCase()}.svg`
    flag.src = assetUrl(image);
    activeTag.innerHTML = language;
})
